import { render, staticRenderFns } from "./IProduct.vue?vue&type=template&id=49e7393c&"
import script from "./IProduct.vue?vue&type=script&lang=ts&"
export * from "./IProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports